import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classnames from "classnames";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import PropTypes from "prop-types";
import React, { useState } from "react";
import styles from "./legal-agreement.css";

function createMarkup(value) {
  return {
    __html: value
  };
}

function LegalAgreement(_ref) {
  var captureType = _ref.captureType,
      className = _ref.className,
      cookiePolicyLink = _ref.cookiePolicyLink,
      requiresOptIn = _ref.requiresOptIn,
      handleLegalChange = _ref.handleLegalChange,
      privacyPolicyLink = _ref.privacyPolicyLink,
      shortVersion = _ref.shortVersion,
      submitText = _ref.submitText,
      termsAndConditionsLink = _ref.termsAndConditionsLink;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      privacyPolicy = _useState2[0],
      setPrivacyPolicy = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      marketingEmails = _useState4[0],
      setMarketingEmails = _useState4[1];

  var privacyPolicyLinkProps = "href=".concat(privacyPolicyLink, " target=\"_blank\"");
  var termsAndConditionsLinkProps = "href=".concat(termsAndConditionsLink, " target=\"_blank\"");
  var cookiePolicyLinkProps = "href=".concat(cookiePolicyLink, " target=\"_blank\"");

  if (requiresOptIn) {
    if (shortVersion) {
      handleLegalChange(true, marketingEmails);
      return React.createElement("div", {
        className: styles.legalAgreement
      }, React.createElement("div", {
        className: styles.checkboxFieldset
      }, React.createElement("input", {
        className: styles.checkbox,
        type: "checkbox",
        name: "marketing_emails",
        checked: marketingEmails,
        id: "marketing-emails",
        onChange: function onChange(e) {
          var action = e.target.checked ? "tick_box" : "untick_box";
          analytics.event(captureType, action, "tickbox_marketing");
          setMarketingEmails(e.target.checked);
          handleLegalChange(true, e.target.checked);
        }
      }), React.createElement("label", {
        className: styles.marketingLabel,
        htmlFor: "marketing-emails",
        dangerouslySetInnerHTML: createMarkup( // "I would like to hear about products, services, and sales, including
        // personalized email alerts from Lyst. You can unsubscribe at any time."
        gettext("account.register.legal_agreement.sign_up_checkbox_label"))
      })));
    } else {
      return React.createElement("div", {
        className: classnames(className, styles.legalAgreement)
      }, React.createElement("div", {
        className: styles.checkboxFieldset
      }, React.createElement("input", {
        className: styles.checkbox,
        type: "checkbox",
        name: "marketing_emails",
        checked: marketingEmails,
        id: "marketing-emails",
        onChange: function onChange(e) {
          var action = e.target.checked ? "tick_box" : "untick_box";
          analytics.event(captureType, action, "tickbox_marketing");
          setMarketingEmails(e.target.checked);
          handleLegalChange(privacyPolicy, e.target.checked);
        }
      }), React.createElement("label", {
        className: styles.marketingLabel,
        htmlFor: "marketing-emails",
        dangerouslySetInnerHTML: createMarkup( // "I would like to hear about products, services, and sales, including
        // personalized email alerts from Lyst. You can unsubscribe at any time."
        gettext("account.register.legal_agreement.sign_up_checkbox_label"))
      })), React.createElement("div", {
        className: styles.checkboxFieldset
      }, React.createElement("input", {
        className: styles.checkbox,
        type: "checkbox",
        name: "privacy_policy",
        id: "privacy-policy",
        checked: privacyPolicy,
        onChange: function onChange(e) {
          var action = e.target.checked ? "tick_box" : "untick_box";
          analytics.event(captureType, action, "tickbox_privacy_policy");
          setPrivacyPolicy(e.target.checked);
          handleLegalChange(e.target.checked, marketingEmails);
        }
      }), React.createElement("label", {
        htmlFor: "privacy-policy",
        dangerouslySetInnerHTML: createMarkup(gettext("account.register.legal_agreement.privacy_policy_checkbox_label", {
          privacy_policy_link_props: privacyPolicyLinkProps
        }))
      })));
    }
  } else {
    handleLegalChange(true, true);
    var country = environment.get("country");
    var text = gettext("account.register.legal_agreement.us_text", {
      submit_btn_text: submitText,
      terms_and_conditions_link_props: termsAndConditionsLinkProps,
      privacy_policy_link_props: privacyPolicyLinkProps,
      cookie_policy_link_props: cookiePolicyLinkProps
    });

    if (country == "US") {
      // "By creating an account, you consent to Lyst’s Terms & Conditions and you agree to receive email updates from Lyst. To learn more about how Lyst uses and protects your personal data, please read Lyst’s Privacy Policy."
      text = gettext("account.register.legal_agreement.sign_up_opt_in_terms_us_version", {
        terms_and_conditions_link_props: termsAndConditionsLinkProps,
        privacy_policy_link_props: privacyPolicyLinkProps
      });
    }

    return React.createElement("div", {
      className: classnames(className, styles.legalAgreementSmall),
      dangerouslySetInnerHTML: createMarkup(text)
    });
  }
}

export default LegalAgreement;
LegalAgreement.propTypes = {
  captureType: PropTypes.string,
  className: PropTypes.string,
  cookiePolicyLink: PropTypes.string,
  requiresOptIn: PropTypes.bool,
  handleLegalChange: PropTypes.func.isRequired,
  privacyPolicyLink: PropTypes.string.isRequired,
  shortVersion: PropTypes.bool,
  submitText: PropTypes.string,
  termsAndConditionsLink: PropTypes.string
};